import React from 'react'
import { MuiColorInput } from 'mui-color-input'

import { useField } from 'formik';

const ColorPicker = ({size = "small", ...props}) => {
  const [field] = useField(props);

  console.log(field, "field");

  const handleChange = (val) => {
    field.onChange({ target: { name: field.name, value: val } });
  };
 
  return <MuiColorInput format="hex" size={size} {...field} onChange={handleChange} />
};

export default ColorPicker;